import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const BulkSummaryDetailWrapper = styled.div`
  .summary-list-container {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .button-center-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 40px;
    ${responsive.MOBILE`
      margin-top: 33px;
    `}
  }
  .footer-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .button-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .dot-container {
    margin-left: 224px;
    margin-right: 224px;
    border-top: 1px dashed #bdbdbd;
    margin-top: 20px;

    ${responsive.MOBILE`
      margin-left: 0px;
      margin-right: 0px;
    `}
  }
  .done-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
  }
  .unprocessed-container {
    margin-top: 10px;
  }
  .label {
    display: flex;
    justify-content: center;
    align-items: center;
    textalign: "center";
    margin-top: 48px;
  }
  .success-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.cirrus_black1};
    color: ${COLORS.cirrus_red};
  }
  .success-image {
    margin-top: 48px;
    width: 80px;
  }
  .success-label {
    display: flex;
    justify-content: center;
    align-items: center;
    textalign: "center";
    margin-top: 10px;
  }
`;
